import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeservices',
  templateUrl: './homeservices.component.html',
  styleUrls: ['./homeservices.component.css']
})
export class HomeservicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
